
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectPath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fullPath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectPath"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archived"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlyAllowMergeIfPipelineSucceeds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowMergeOnSkippedPipeline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mergeRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"iid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"iid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoMergeEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableAutoMergeStrategies"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commitCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conflicts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detailedMergeStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diffHeadSha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mergeError"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mergeStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mergeable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mergeableDiscussionsState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headPipeline"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldBeRebased"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceBranchExists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetBranchExists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canMerge"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"draft"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":663}};
    doc.loc.source = {"body":"query getState($projectPath: ID!, $iid: String!) {\n  project(fullPath: $projectPath) {\n    id\n    archived\n    onlyAllowMergeIfPipelineSucceeds\n    allowMergeOnSkippedPipeline\n    mergeRequest(iid: $iid) {\n      id\n      autoMergeEnabled\n      availableAutoMergeStrategies\n      commitCount\n      conflicts\n      detailedMergeStatus\n      diffHeadSha\n      mergeError\n      mergeStatus\n      mergeable\n      mergeableDiscussionsState\n      headPipeline {\n        id\n        status\n        warnings\n      }\n      shouldBeRebased\n      sourceBranchExists\n      state\n      targetBranchExists\n      userPermissions {\n        canMerge\n      }\n      draft\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getState"] = oneQuery(doc, "getState");
        
